import moment from 'moment';
import {
	workspaceMerchantStorageKey,
	workspaceBranchStorageKey,
	workspaceBranchIdsStorageKey,
	workspaceSubscriptionsStorageKey,
	workspaceAssignedLicenseStorageKey,
	workspaceReportFilterStorageKey,
	defaultReportFilter,
} from '@/configs/main';
import getSymbolFromCurrency from 'currency-symbol-map';

export const getCurrentMerchant = () => {
	let merchant = null;
	try {
		if (window.targetStorage.getItem(workspaceMerchantStorageKey)) {
			merchant = JSON.parse(
				window.targetStorage.getItem(workspaceMerchantStorageKey)
			);
		}
	} catch (error) {
		console.error(
			'>>> src/helpers/Utils.js -> getCurrentMerchant error:',
			error
		);
	}
	return merchant;
};

export const setCurrentMerchant = (merchant) => {
	try {
		if (merchant) {
			window.targetStorage.setItem(
				workspaceMerchantStorageKey,
				JSON.stringify(merchant)
			);
		} else {
			window.targetStorage.removeItem(workspaceMerchantStorageKey);
		}
	} catch (error) {
		console.error(
			'>>> src/helpers/Utils.js -> setCurrentMerchant error:',
			error
		);
	}
};

export const getCurrentCurrency = () => {
	const merchant = getCurrentMerchant();
	return merchant.currency ?? 'AUD';
};

export const getCurrencySymbol = () => {
	return getSymbolFromCurrency(getCurrentCurrency());
};

export const getCurrentBranch = () => {
	let branch = { branchId: '*', branchName: 'All' };
	try {
		if (window.targetStorage.getItem(workspaceBranchStorageKey)) {
			branch = JSON.parse(
				window.targetStorage.getItem(workspaceBranchStorageKey)
			);
		}
	} catch (error) {
		console.error('>>> src/helpers/Utils.js -> getCurrentBranch error:', error);
	}
	return branch;
};

export const setCurrentBranch = (branch) => {
	try {
		if (branch) {
			window.targetStorage.setItem(
				workspaceBranchStorageKey,
				JSON.stringify(branch)
			);
		} else {
			window.targetStorage.removeItem(workspaceBranchStorageKey);
		}
	} catch (error) {
		console.error(
			'>>> src/helpers/Utils.js -> setCurrentBranch error: ',
			error
		);
	}
};

export const getBranchIds = () => {
	let branches = '';
	try {
		if (window.targetStorage.getItem(workspaceBranchIdsStorageKey)) {
			branches = window.targetStorage.getItem(workspaceBranchIdsStorageKey);
		}
	} catch (error) {
		console.error('>>> src/helpers/Utils.js -> getBranchIds error:', error);
	}
	return branches;
};

export const setBranchIds = (branches) => {
	try {
		if (branches) {
			window.targetStorage.setItem(workspaceBranchIdsStorageKey, branches);
		} else {
			window.targetStorage.removeItem(workspaceBranchIdsStorageKey);
		}
	} catch (error) {
		console.error('>>> src/helpers/Utils.js -> setBranchIds error: ', error);
	}
};

export const getBranchName = (branchId) => {
	const merchant = getCurrentMerchant();
	const branch = merchant.branches.find((el) => el.branchId === branchId);
	return branch ? branch.branchName : branchId;
};

export const getBranchTZ = (branchId) => {
	const merchant = getCurrentMerchant();
	const branch = merchant.branches.find((el) => el.branchId === branchId);
	if (branch) {
		return branch.timezone;
	}
	return merchant.timezone || '';
};

export const getSubscriptions = () => {
	let subscriptions = [];
	try {
		if (window.targetStorage.getItem(workspaceSubscriptionsStorageKey)) {
			subscriptions = JSON.parse(
				window.targetStorage.getItem(workspaceSubscriptionsStorageKey)
			);
		}
	} catch (error) {
		console.error('>>> src/helpers/Utils.js -> getSubscriptions error:', error);
	}
	return subscriptions;
};

export const setSubscriptions = (subscriptions) => {
	try {
		if (subscriptions) {
			window.targetStorage.setItem(
				workspaceSubscriptionsStorageKey,
				JSON.stringify(subscriptions)
			);
		} else {
			window.targetStorage.removeItem(workspaceSubscriptionsStorageKey);
		}
	} catch (error) {
		console.error(
			'>>> src/helpers/Utils.js -> setSubscriptions error: ',
			error
		);
	}
};

export const getAssignedLicenses = () => {
	let assignedLicenses = [];
	try {
		if (window.targetStorage.getItem(workspaceAssignedLicenseStorageKey)) {
			assignedLicenses = JSON.parse(
				window.targetStorage.getItem(workspaceAssignedLicenseStorageKey)
			);
		}
	} catch (error) {
		console.error('>>> src/helpers/Utils.js -> getCurrentBranch error:', error);
	}
	return assignedLicenses;
};

export const setAssignedLicenses = (assignedLicenses) => {
	try {
		if (assignedLicenses) {
			window.targetStorage.setItem(
				workspaceAssignedLicenseStorageKey,
				JSON.stringify(assignedLicenses)
			);
		} else {
			window.targetStorage.removeItem(workspaceAssignedLicenseStorageKey);
		}
	} catch (error) {
		console.error(
			'>>> src/helpers/Utils.js -> setCurrentBranch error: ',
			error
		);
	}
};

export const getReportFilter = () => {
	let filter = defaultReportFilter;
	try {
		if (localStorage.getItem(workspaceReportFilterStorageKey)) {
			filter = JSON.parse(
				localStorage.getItem(workspaceReportFilterStorageKey)
			);
			filter.start = moment(filter.start);
			filter.end = moment(filter.end);
			filter.vsStart = moment(filter.vsStart);
			filter.vsEnd = moment(filter.vsEnd);
		}
	} catch (error) {
		console.error('>>> src/helpers/Utils.js -> getReportFilter error:', error);
	}
	if (!filter.locationIds || filter.locationIds === '') {
		const merchant = getCurrentMerchant();
		filter.locationIds = merchant?.branches.map((el) => el.branchId).join(',');
	}
	return filter;
};

export const setReportFilter = (filter) => {
	try {
		if (filter) {
			localStorage.setItem(
				workspaceReportFilterStorageKey,
				JSON.stringify(filter)
			);
		} else {
			localStorage.removeItem(workspaceReportFilterStorageKey);
		}
	} catch (error) {
		console.error('>>> src/helpers/Utils.js -> setReportFilter error: ', error);
	}
};
